import Isotope from 'isotope-layout/dist/isotope.pkgd.min';

export default class Brochures {

    constructor()
    {
        setTimeout( () => {
            Brochures.initializeIsotope();
        }, 300 );
    }

    static initializeIsotope()
    {
        const grid     = document.querySelector( '[isotope-grid]' ),
            item     = '[isotope-item]',
            filters  = '[isotope-filters]',
            $filters = $( filters ),
            active   = 'current',
            gutter_size = 20;

        if ( document.body.contains( grid ) ) {

            const iso = new Isotope( grid, {
                masonry: {
                    itemSelector: item,
                    gutter: gutter_size,
                    columnWidth: '.grid-sizer',
                }
            } );

            if ( $filters.length > 0 ) {
                // Filter items on button click
                $filters.on( 'click', '.filterItem', function () {
                    const filterValue = $( this ).attr( 'data-filter' );
                    iso.arrange( { filter: filterValue } );
                } );

                // Change class on click
                $filters.each( function ( i, buttonGroup ) {
                    const $buttonGroup = $( buttonGroup );
                    $buttonGroup.on( 'click', '.filterItem', function () {
                        $buttonGroup.find( '.' + active ).removeClass( active );
                        $( this ).addClass( active );
                    } );
                } );
            }

            // Group space filter
            const params = window.location.search;

            if (params == '?groupe=true') {
                const group =  '[data-filter=".groupes"]';
                const all =  '[data-filter="*:not(.pro)"]';
                const filterGroup = $( group ).attr( 'data-filter' );
                $(all).removeClass( active );
                $( group ).addClass( active );
                iso.arrange( { filter: filterGroup } );
            }

            if(params != '' && params != '?groupe=true') {
                const slug = params.substring(1),
                    selected =  '[data-filter=".' + slug + '"]',
                    all =  '[data-filter="*:not(.pro)"]',
                    filterSelected = $( selected ).attr( 'data-filter' );
                $(all).removeClass( active );
                $( selected ).addClass( active );
                iso.arrange( { filter: filterSelected } );
            }

            // Pro space filter
            if (params == '?pro=true') {
                const pro =  '[data-filter=".pro"]';
                const all =  '[data-filter="*"]';
                const filterPro = $( pro ).attr( 'data-filter' );
                $(all).removeClass( active );
                $( pro ).addClass( active );
                iso.arrange( { filter: filterPro } );
            }

            if(params != '' && params != '?pro=true') {
                const slug = params.substring(1),
                    selected =  '[data-filter=".' + slug + '"]',
                    all =  '[data-filter="*"]',
                    filterSelected = $( selected ).attr( 'data-filter' );
                $(all).removeClass( active );
                $( selected ).addClass( active );
                iso.arrange( { filter: filterSelected } );
            }

            // Presse space filter
            if (params == '?presse=true') {
                const presse =  '[data-filter=".presse"]';
                const all =  '[data-filter="*:not(.pro)"]';
                const filterPresse = $( presse ).attr( 'data-filter' );
                $(all).removeClass( active );
                $( presse ).addClass( active );
                iso.arrange( { filter: filterPresse } );
            }

            if(params != '' && params != '?presse=true') {
                const slug = params.substring(1),
                    selected =  '[data-filter=".' + slug + '"]',
                    all =  '[data-filter="*:not(.pro)"]',
                    filterSelected = $( selected ).attr( 'data-filter' );
                $(all).removeClass( active );
                $( selected ).addClass( active );
                iso.arrange( { filter: filterSelected } );
            }

            const initFilterValue = $( '.current' ).attr( 'data-filter' );
            iso.arrange( { filter: initFilterValue } );
        }
    }
}
